import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import patientPortalApi from "@/lib/patientPortalApi";

const PatientPortalAuthContext = createContext(null);
const isPatientPortalProtectedPath = () => {
  const path = window.location.pathname;
  return path === "/area-paciente" || path === "/area-paciente/";
};

export function PatientPortalAuthProvider({ children }) {
  const [patient, setPatient] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!isPatientPortalProtectedPath()) {
      setLoading(false);
      return;
    }
    patientPortalApi.get("/patient-auth/me").then((response) => setPatient(response.data?.authenticated === false ? null : response.data)).catch(() => setPatient(null)).finally(() => setLoading(false));
  }, []);

  const login = useCallback(async (email, password) => {
    const { data } = await patientPortalApi.post("/patient-auth/login", { email, password });
    setPatient(data.patient);
    return data.patient;
  }, []);

  const logout = useCallback(async () => {
    try {
      await patientPortalApi.post("/patient-auth/logout");
    } finally {
      setPatient(null);
    }
  }, []);

  const value = useMemo(() => ({ patient, loading, login, logout }), [patient, loading, login, logout]);
  return <PatientPortalAuthContext.Provider value={value}>{children}</PatientPortalAuthContext.Provider>;
}

export const usePatientPortalAuth = () => useContext(PatientPortalAuthContext);